<template>
	<Menu
		v-slot="{ open }"
		as="div"
		class="dropdown relative inline-block text-left"
	>
		<div class="flex space-x-1">
			<slot name="menu-title" />
			<MenuButton :class="[menuButtonClass]" as="div">
				<div class="flex items-center">
					<slot name="menu-button" />
					<div
						v-if="showCaret"
						class="caret"
						:class="open ? 'open' : ''"
					>
						<slot name="caret">
							<div
								class="on-open-rotate--90 ml-1 cursor-pointer font-medium text-gray-600 duration-200"
							>
								<IconArrowDown class="text-gray-500" />
							</div>
						</slot>
					</div>
				</div>
			</MenuButton>
		</div>

		<Transition
			enter-active-class="transition ease-out duration-100"
			enter-from-class="transform opacity-0 scale-95"
			enter-to-class="transform opacity-100 scale-100"
			leave-active-class="transition ease-in duration-75"
			leave-from-class="transform opacity-100 scale-100"
			leave-to-class="transform opacity-0 scale-95"
		>
			<MenuItems
				v-if="true"
				:class="[
					position === 'left' ? 'right-0' : 'left-0',
					zIndex,
					label,
				]"
				class="ring-none absolute mt-2 w-[230px] origin-top-right rounded-md bg-white p-2.5 shadow-lg focus:outline-none"
			>
				<div>
					<MenuItem
						v-for="(menuItem, key) in menuItems"
						v-slot="{ active, close }"
						:key="key"
					>
						<a
							:class="[
								active
									? 'bg-gray-100 font-medium text-blue-400 duration-200'
									: 'font-medium text-gray-600 duration-200',
								'block p-3',
							]"
							:href="menuItem.href ? menuItem.href : ''"
							@click="
								(onClickMenuItem(menuItem, $event), close())
							"
						>
							{{ menuItem.label }}
						</a>
					</MenuItem>
				</div>
			</MenuItems>
		</Transition>
	</Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import IconArrowDown from '@/assets/svg/common/ico-arrow_down.svg'

const props = defineProps({
	menuButtonClass: {
		type: String,
		default: '',
		required: false,
	},
	position: {
		type: String,
		default: 'left',
		required: false,
	},
	zIndex: {
		type: String,
		default: 'z-10',
		required: false,
	},
	menuItems: {
		type: Array,
		required: true,
	},
	showCaret: {
		type: Boolean,
		default: true,
		required: false,
	},
	label: {
		type: String,
		default: '',
		required: false,
	},
})

const emit = defineEmits(['clickMenuItem'])

const onClickMenuItem = (menuItem, e) => {
	if (!menuItem.href) {
		e.preventDefault()
	}

	emit('clickMenuItem', menuItem)
}
</script>
